import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaPlus, FaRedoAlt, FaFilter } from 'react-icons/fa';
import {
  Container,
  Card,
  Button,
  Row,
  Col,
  Form,
  Badge,
} from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { v4 } from 'uuid';
import moment from 'moment';

import axios from '../../services/axios';
import Loading from '../../components/Loading';
import Breadcrumbs from '../../components/Breadcrumbs';
import DataTable from '../../components/DataTable';
import ButtonModal from '../../components/ModalConfirmation/ButtonModal';
import { useNotification } from '../../components/Notification/NotificationContext';
import ErrorProcessor from '../../components/ErrorProcessor';
import ToXLSX from '../../components/Exports/ToXlsx';
import CardHeaderMore from '../../components/Cards/CardHeaderMore';

export default function Customers() {
  const routeName = '/customers';
  const dataName = 'Cliente';
  const titleName = 'Clientes';
  const navigate = useNavigate();
  const [apiErrors, setApiErrors] = useState({});
  const notification = useNotification();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const userData = useSelector((state) => state.auth.user);
  const [dataExport, setDataExport] = useState([]);
  const filterOptionsCompany = useRef([]);
  const [filterOptionsDiscount, setFilterOptionsDiscount] = useState([]);
  const filterOptionsStatusCustomer = useRef([]);
  const filterOptionsStatusContract = useRef([]);
  const [filterApplied, setFilterApplied] = useState(false);
  const [filterName, setFilterName] = useState('');
  const [filterLastname, setFilterLastname] = useState('');
  const [filterCompany, setFilterCompany] = useState('');
  const [filterCity, setFilterCity] = useState('');
  const [filterState, setFilterState] = useState('');
  const [filterDocId, setFilterDocId] = useState('');
  const [filterDiscount, setFilterDiscount] = useState('');
  const [filterStatusCustomer, setFilterStatusCustomer] = useState(1);
  const [filterStatusContract, setFilterStatusContract] = useState('');
  const [filterPartner, setFilterPartner] = useState('');
  const [dataLoaded, setDataLoaded] = useState(false);

  const tableColumns = useMemo(
    () => [
      {
        Header: 'Nome completo',
        accessor: 'fullname',
      },
      {
        Header: 'CPF / CNPJ',
        accessor: 'cpf_cnpj',
      },
      {
        Header: 'Empresa',
        accessor: 'company_name',
      },
      {
        Header: 'Situação contratual',
        accessor: 'status_contract',
      },
      {
        Header: 'Situação cliente',
        accessor: 'status_customer',
      },
    ],
    []
  );

  const exportDataConstruct = (customers) => {
    const formatedExportData = [];
    customers.forEach((customerObj) => {
      const customerFormat = {
        Data_cadastro: moment
          .utc(customerObj.created_at)
          .format('DD/MM/YYYY HH:mm:ss'),
        Data_atualização: moment
          .utc(customerObj.updated_at)
          .format('DD/MM/YYYY HH:mm:ss'),
        Nome: customerObj.name,
        Sobrenome: customerObj.lastname || '',
        CPF_CNPJ: customerObj.cpf_cnpj || '',
        Empresa: customerObj.Company.name,
        Tipo_de_pessoa: customerObj.type_person,
        Data_nascimento: moment.utc(customerObj.dob).format('DD/MM/YYYY'),
        Idade: customerObj.age || '',
        Email: customerObj.email || '',
        Telefone_residêncial: customerObj.landline_phone || '',
        Telefone_comercial: customerObj.business_phone || '',
        Celular: customerObj.mobile_phone || '',
        Telefone_adicional: customerObj.additional_phone || '',
        Observações: customerObj.notes || '',
        Situação_do_cliente: customerObj.status === 1 ? 'Ativo' : 'Inativo',
        Motivo_desativação: customerObj.reason_deactivation,
        CEP: customerObj.CustomerAddresses[0]
          ? customerObj.CustomerAddresses[0].postal_code
          : '',
        Logradouro: customerObj.CustomerAddresses[0]
          ? customerObj.CustomerAddresses[0].street
          : '',
        Número: customerObj.CustomerAddresses[0]
          ? customerObj.CustomerAddresses[0].number
          : '',
        Complemento: customerObj.CustomerAddresses[0]
          ? customerObj.CustomerAddresses[0].complement
          : '',
        Bairro: customerObj.CustomerAddresses[0]
          ? customerObj.CustomerAddresses[0].neighborhood
          : '',
        Cidade_Município: customerObj.CustomerAddresses[0]
          ? customerObj.CustomerAddresses[0].city
          : '',
        UF: customerObj.CustomerAddresses[0]
          ? customerObj.CustomerAddresses[0].state
          : '',
        Descrição_endereço: customerObj.CustomerAddresses[0]
          ? customerObj.CustomerAddresses[0].description
          : '',
        Código_banco: customerObj.CustomerPayments[0]
          ? customerObj.CustomerPayments[0].bank_code
          : '',
        Nome_banco: customerObj.CustomerPayments[0]
          ? customerObj.CustomerPayments[0].bank_name
          : '',
        Agência: customerObj.CustomerPayments[0]
          ? customerObj.CustomerPayments[0].bank_branch
          : '',
        Conta_e_dígito: customerObj.CustomerPayments[0]
          ? customerObj.CustomerPayments[0].bank_account
          : '',
        Tipo_recebimento: customerObj.CustomerPayments[0]
          ? customerObj.CustomerPayments[0].bank_account_type
          : '',
        Titular_conta: customerObj.CustomerPayments[0]
          ? customerObj.CustomerPayments[0].account_owner
          : '',
        Chave_Pix: customerObj.CustomerPayments[0]
          ? customerObj.CustomerPayments[0].bank_pix
          : '',
        Número_beneficiário: customerObj.CustomerPayments[0]
          ? customerObj.CustomerPayments[0].beneficiary_number
          : '',
        Valor_benefício_anterior: customerObj.CustomerPayments[0]
          ? customerObj.CustomerPayments[0].previous_benefit_amount
          : '',
        Espécie: customerObj.CustomerPayments[0]
          ? customerObj.CustomerPayments[0].category
          : '',
        DIB: customerObj.CustomerPayments[0]
          ? customerObj.CustomerPayments[0].dib
          : '',
        Descrição_Contrato: customerObj.CustomerContracts[0]
          ? customerObj.CustomerContracts[0].name
          : '',
        Valor_Contrato: customerObj.CustomerContracts[0]
          ? customerObj.CustomerContracts[0].value
          : '',
        Número_Contrato: customerObj.CustomerContracts[0]
          ? customerObj.CustomerContracts[0].number
          : '',
        Forma_desconto_Contrato: customerObj.CustomerContracts[0]
          ? customerObj.CustomerContracts[0].contractual_discount_id
          : '',
        Parceiro_Contrato: customerObj.CustomerContracts[0]
          ? customerObj.CustomerContracts[0].business_partner
          : '',
        Comissão_parceiro_Contrato: customerObj.CustomerContracts[0]
          ? customerObj.CustomerContracts[0].partner_commission
          : '',
        Data_contratação_Contrato:
          customerObj.CustomerContracts[0] &&
          customerObj.CustomerContracts[0].date_of_contract
            ? moment
                .utc(customerObj.CustomerContracts[0].date_of_contract)
                .format('DD/MM/YYYY')
            : '',
        // eslint-disable-next-line no-nested-ternary
        Situação_contratual: customerObj.CustomerContracts[0]
          ? customerObj.CustomerContracts[0].status === 1
            ? 'Adimplente'
            : 'Inadimplente'
          : '',
      };

      formatedExportData.push(customerFormat);
    });

    setDataExport(formatedExportData);
  };

  const getData = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(`${routeName}/filter`, {
        name: filterName,
        lastname: filterLastname,
        company_id: filterCompany,
        cpf_cnpj: filterDocId,
        status: filterStatusCustomer,
        status_contract: filterStatusContract,
        partner_contract: filterPartner,
        discount_contract: filterDiscount,
        city_address: filterCity,
        state_address: filterState,
      });

      exportDataConstruct(response.data);
      setData(response.data);
    } catch (err) {
      setApiErrors(err);
      setData([]);
    } finally {
      setIsLoading(false);
    }
  }, [
    filterName,
    filterLastname,
    filterDocId,
    filterStatusCustomer,
    filterStatusContract,
    filterPartner,
    filterDiscount,
    filterCity,
    filterCompany,
    filterState,
  ]);

  const getFilter = useCallback(async () => {
    try {
      setIsLoading(true);

      const optionsCompanies = [{ value: '', label: '-- Selecione --' }];

      const getCompanies = await axios.get(`/companies`);
      if (getCompanies) {
        getCompanies.data.forEach((company) => {
          optionsCompanies.push({
            value: company.id,
            label: company.name,
          });
        });
      }

      filterOptionsCompany.current = optionsCompanies;

      filterOptionsStatusCustomer.current = [
        { value: 1, label: 'Ativo' },
        { value: 0, label: 'Inativo' },
        { value: '', label: 'Todas' },
      ];

      filterOptionsStatusContract.current = [
        { value: '', label: 'Todas' },
        { value: 1, label: 'Adimplente' },
        { value: 0, label: 'Inadimplente' },
      ];
    } catch (err) {
      setApiErrors(err);
    } finally {
      setIsLoading(false);
      setDataLoaded(true);
    }
  }, []);

  const getDiscounts = useCallback(async () => {
    try {
      const optionsDiscount = [{ value: '', label: '-- Selecione --' }];
      const discounts = await axios.get(`/discounts`);
      if (discounts) {
        discounts.data.forEach((discount) => {
          if (Number(filterCompany) === discount.company_id) {
            optionsDiscount.push({
              value: discount.id,
              label: discount.name,
            });
          }
        });
      }

      setFilterOptionsDiscount(optionsDiscount);
    } catch (err) {
      setApiErrors(err);
    }
  }, [filterCompany]);

  const resetFilter = useCallback(() => {
    setFilterName('');
    setFilterLastname('');
    setFilterCompany('');
    setFilterCity('');
    setFilterState('');
    setFilterDocId('');
    setFilterDiscount('');
    setFilterStatusCustomer(1);
    setFilterStatusContract('');
  }, []);

  useEffect(() => {
    getFilter();
    getData();
  }, []);

  useEffect(() => {
    if (filterApplied) {
      getData();
      setFilterApplied(false); // Resetar o estado do filtro aplicado
    }
  }, [filterApplied]);

  useEffect(() => {
    getDiscounts();
  }, [filterCompany]);

  const confirmDelete = useCallback(
    async (id) => {
      try {
        setIsLoading(true);
        await axios.delete(`${routeName}/${id}`);
        notification(`${dataName} removido com sucesso`, 'success');
        const updated = data.filter((channel) => channel.id !== id);
        setData(updated);
      } catch (err) {
        setApiErrors(err);
      } finally {
        setIsLoading(false);
      }
    },
    [setIsLoading, notification, data]
  );

  const tableData = useMemo(() => {
    return data.map((dataObject) => {
      const linksAction = [
        {
          onclick: () => {
            navigate(`${routeName}/${dataObject.id}/edit`);
          },
          faicon: 'faEdit',
          text: 'Atualizar',
        },
      ];

      if (userData.isadmin === 1) {
        linksAction.push({
          custom: (
            <ButtonModal
              onConfirm={() => confirmDelete(dataObject.id)}
              message={`Confirma remoção do ${dataName} ${dataObject.name}?`}
              buttonProps={{ text: 'Remover', faicon: 'faTrash' }}
              textModal={{
                title: `Remover ${dataName}`,
                textConfirm: 'Remover',
              }}
              dropdown
            />
          ),
        });
      }

      const statusCustomer = (
        <Badge
          bg={`${dataObject.status === 1 ? 'success' : 'danger'}-light`}
          text={dataObject.status === 1 ? 'success' : 'danger'}
        >
          <span className="indicator" />
          {dataObject.status === 1 ? 'Ativo' : 'Inativo'}
        </Badge>
      );

      let statusContract = '';

      if (dataObject.CustomerContracts && dataObject.CustomerContracts[0]) {
        statusContract = (
          <Badge
            bg={`${dataObject.CustomerContracts[0].status === 1 ? 'success' : 'danger'}-light`}
            text={
              dataObject.CustomerContracts[0].status === 1
                ? 'success'
                : 'danger'
            }
          >
            <span className="indicator" />
            {dataObject.CustomerContracts[0].status === 1
              ? 'Adimplente'
              : 'Inadimplente'}
          </Badge>
        );
      }

      return {
        company_name: dataObject.Company.name,
        status_customer: (
          <div className="d-flex justify-content-between">
            <span>{statusCustomer}</span>
            <CardHeaderMore links={linksAction} className="" />
          </div>
        ),
        status_contract: statusContract,
        fullname: `${dataObject.name} ${dataObject.lastname}`,
        ...dataObject,
      };
    });
  }, [data, confirmDelete, userData]);

  return (
    <Container fluid className="px-lg-4 px-xl-5">
      <Loading isLoading={isLoading} />
      <Breadcrumbs title={titleName} />
      <div className="page-header d-flex justify-content-between align-items-center">
        <h1 className="page-heading">{titleName}</h1>
        <div>
          <Link to={`${routeName}/new`}>
            <Button variant="primary" className="text-uppercase">
              <FaPlus /> Cadastrar
            </Button>
          </Link>
        </div>
      </div>
      <section>
        {dataLoaded ? (
          <>
            <Row className="mb-1">
              <Col lg={12}>
                <h6 className="page-heading">
                  {filterName && <b className="ms-2"> | Nome : {filterName}</b>}
                  {filterLastname && (
                    <b className="ms-2"> | Sobrenome : {filterLastname}</b>
                  )}
                  {filterDocId && (
                    <b className="ms-2"> | CPF / CNPJ : {filterDocId}</b>
                  )}
                  {filterCompany && (
                    <b className="ms-2">
                      | Empresa :{' '}
                      {filterOptionsCompany.current.find(
                        (company) =>
                          Number(company.value) === Number(filterCompany)
                      ) !== undefined
                        ? filterOptionsCompany.current.find(
                            (company) =>
                              Number(company.value) === Number(filterCompany)
                          ).label
                        : null}
                    </b>
                  )}
                  {filterCity && (
                    <b className="ms-2"> | Cidade / Município : {filterCity}</b>
                  )}
                  {filterState && <b className="ms-2"> | UF : {filterState}</b>}
                  {filterDiscount && (
                    <b className="ms-2">
                      | Desconto contratual :{' '}
                      {filterOptionsDiscount.find(
                        (discount) =>
                          Number(discount.value) === Number(filterDiscount)
                      ) !== undefined
                        ? filterOptionsDiscount.find(
                            (discount) =>
                              Number(discount.value) === Number(filterDiscount)
                          ).label
                        : null}
                    </b>
                  )}
                  {filterPartner && (
                    <b className="ms-2"> | Parceiro : {filterPartner}</b>
                  )}
                  {filterStatusCustomer && (
                    <b className="ms-2">
                      | Situação do cliente :{' '}
                      {filterOptionsStatusCustomer.current.find(
                        (status) =>
                          Number(status.value) === Number(filterStatusCustomer)
                      ) !== undefined
                        ? filterOptionsStatusCustomer.current.find(
                            (status) =>
                              Number(status.value) ===
                              Number(filterStatusCustomer)
                          ).label
                        : null}
                    </b>
                  )}
                  {filterStatusContract && (
                    <b className="ms-2">
                      | Situação contratual :{' '}
                      {filterOptionsStatusContract.current.find(
                        (status) =>
                          Number(status.value) === Number(filterStatusContract)
                      ) !== undefined
                        ? filterOptionsStatusContract.current.find(
                            (status) =>
                              Number(status.value) ===
                              Number(filterStatusContract)
                          ).label
                        : null}
                    </b>
                  )}
                </h6>
              </Col>
            </Row>
            <Card className="card-table mb-5">
              <ErrorProcessor error={apiErrors} />
              <DataTable
                items={tableData}
                columns={tableColumns}
                defaultPageSize={5}
                customActions={
                  <>
                    <ButtonModal
                      onConfirm={() => setFilterApplied(true)}
                      message={
                        <Row sm={12}>
                          <Col
                            sm={12}
                            className="mb-0 d-flex justify-content-end"
                          >
                            <Button
                              title="Clique para limpar o filtro"
                              size="sm"
                              variant="info"
                              onClick={resetFilter}
                            >
                              <FaRedoAlt className="text-white" />
                            </Button>
                          </Col>
                          <Col sm={6} className="mb-2">
                            <Form.Label>Nome:</Form.Label>
                            <Form.Control
                              value={filterName}
                              onInput={(e) => {
                                setFilterName(e.target.value);
                              }}
                            />
                          </Col>
                          <Col sm={6} className="mb-2">
                            <Form.Label>Sobrenome:</Form.Label>
                            <Form.Control
                              value={filterLastname}
                              onInput={(e) => {
                                setFilterLastname(e.target.value);
                              }}
                            />
                          </Col>
                          <Col sm={6} className="mb-2">
                            <Form.Label>CPF ou CNPJ :</Form.Label>
                            <Form.Control
                              value={filterDocId}
                              onInput={(e) => {
                                setFilterDocId(e.target.value);
                              }}
                            />
                          </Col>
                          <Col sm={6} className="mb-2">
                            <Form.Label>Empresa:</Form.Label>
                            <Form.Control
                              value={filterCompany}
                              as="select"
                              onChange={(e) => {
                                setFilterCompany(e.target.value);
                              }}
                            >
                              {filterOptionsCompany.current.map((value) => (
                                <option key={v4()} value={value.value}>
                                  {value.label}
                                </option>
                              ))}
                            </Form.Control>
                          </Col>
                          <Col sm={6} className="mb-2">
                            <Form.Label>Cidade / Município:</Form.Label>
                            <Form.Control
                              value={filterCity}
                              onInput={(e) => {
                                setFilterCity(e.target.value);
                              }}
                            />
                          </Col>
                          <Col sm={6} className="mb-2">
                            <Form.Label>UF:</Form.Label>
                            <Form.Control
                              value={filterState}
                              onInput={(e) => {
                                setFilterState(e.target.value);
                              }}
                            />
                          </Col>
                          <Col sm={6} className="mb-2">
                            <Form.Label>Desconto contratual:</Form.Label>
                            <Form.Control
                              value={filterDiscount}
                              as="select"
                              onChange={(e) => {
                                setFilterDiscount(e.target.value);
                              }}
                            >
                              {filterOptionsDiscount.map((value) => (
                                <option key={v4()} value={value.value}>
                                  {value.label}
                                </option>
                              ))}
                            </Form.Control>
                          </Col>
                          <Col sm={6} className="mb-2">
                            <Form.Label>Parceiro:</Form.Label>
                            <Form.Control
                              value={filterPartner}
                              onInput={(e) => {
                                setFilterPartner(e.target.value);
                              }}
                            />
                          </Col>
                          <Col sm={6}>
                            <Form.Label>Situação do cliente:</Form.Label>
                            <Form.Control
                              value={filterStatusCustomer}
                              as="select"
                              onChange={(e) => {
                                setFilterStatusCustomer(e.target.value);
                              }}
                            >
                              {filterOptionsStatusCustomer.current.map(
                                (value) => (
                                  <option key={v4()} value={value.value}>
                                    {value.label}
                                  </option>
                                )
                              )}
                            </Form.Control>
                          </Col>
                          <Col sm={6}>
                            <Form.Label>Situação contratual:</Form.Label>
                            <Form.Control
                              value={filterStatusContract}
                              as="select"
                              onChange={(e) => {
                                setFilterStatusContract(e.target.value);
                              }}
                            >
                              {filterOptionsStatusContract.current.map(
                                (value) => (
                                  <option key={v4()} value={value.value}>
                                    {value.label}
                                  </option>
                                )
                              )}
                            </Form.Control>
                          </Col>
                        </Row>
                      }
                      buttonProps={{
                        variant: 'secondary',
                        className: 'shadow text-white me-2',
                        size: 20,
                        style: { height: '35px' },
                      }}
                      textModal={{
                        title: 'Filtrar pesquisa',
                        textConfirm: 'Filtrar',
                      }}
                    >
                      <FaFilter />
                      <b className="ms-2">Abrir Filtro</b>
                    </ButtonModal>
                    <ToXLSX data={dataExport} fileName="clientes.xlsx" />
                  </>
                }
              />
            </Card>
          </>
        ) : null}
      </section>
    </Container>
  );
}
